import CheckoutTotal from './checkout-total';

export default CheckoutTotal;
